import { FormaInformacaoEnum } from "../interfaces/FormaInformacaoEnum";

const LGPD_RECIPIENT_EMAIL = "ouvidoria@telemont.com.br";

export interface SendFormularioLgpdPayload {
  nome: string;
  cpf: string;
  rg: string;
  telefone: string;
  quemSolicita: string;
  outroSolicitante?: string;
  dadosSolicitados: string;
  formaInformacao: FormaInformacaoEnum;
}

export async function sendFormularioLgpdEmail(
  payload: SendFormularioLgpdPayload,
): Promise<void> {
  const quemSolicita =
    payload.quemSolicita === "Outro" && payload.outroSolicitante
      ? `Outro: ${payload.outroSolicitante}`
      : payload.quemSolicita;

  const formUrl =
    typeof window !== "undefined"
      ? `${window.location.origin}${window.location.pathname}`
      : "https://telemont.com.br/formulario-lgpd";

  const response = await fetch(
    `https://formsubmit.co/ajax/${LGPD_RECIPIENT_EMAIL}`,
    {
      method: "POST",
      // FormSubmit exige Referer; força envio mesmo com Referrer-Policy restritiva.
      referrerPolicy: "origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        _subject: "Nova requisição LGPD - Titular de Dados Pessoais",
        _template: "table",
        _captcha: "false",
        _url: formUrl,
        Nome: payload.nome,
        CPF: payload.cpf,
        RG: payload.rg,
        Telefone: payload.telefone,
        "Quem solicita": quemSolicita,
        "Dados solicitados": payload.dadosSolicitados,
        "Forma de informação": payload.formaInformacao,
      }),
    },
  );

  if (!response.ok) {
    throw new Error("Falha ao enviar formulário");
  }

  const data = await response.json();

  if (data.success !== "true" && data.success !== true) {
    throw new Error("Falha ao enviar formulário");
  }
}
